// extracted by mini-css-extract-plugin
module.exports = {"timeline":"EventsTab_timeline__1FzJe"};